import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Grid,
	StyleRules,
	Typography,
	withStyles,
} from '@material-ui/core';
import { History } from 'history';
import * as React from 'react';
import { FormattedDate, InjectedIntl, injectIntl } from 'react-intl';

import CarrierViewComponent from '@app/components/carriers/carrier-view.component';
import Icon from '@app/components/shared/icon.component';
import SecretKeySettingComponent from '@app/components/shared/secret-key-setting.component';

import { UserRole } from '@app/app.enum';
import * as constants from '@app/constants';
import environment from '@app/environments/environment';
import * as models from '@app/models';
import Injector from '@app/services';

import { AccountService } from '@app/services/account.service';
import { IntlService } from '@app/services/intl.service';
import { SharedService } from '@app/services/shared.service';

const intlService: IntlService = Injector.get(IntlService);
const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);

const styles: StyleRules = {};

interface IAccountAppState {
	app: models.IAccountAppResponseVM;
	apiCredsToRegenerate: string;
	signinUrl: string;
	customerEmail: string;
	userRole: UserRole;
}

class AccountAppComponent extends React.Component<
	{ history: History<any>; classes: any; intl: InjectedIntl },
	IAccountAppState
> {
	constructor(props: { history: History<any>; classes: any; intl: InjectedIntl }) {
		super(props);
		this.state = {
			apiCredsToRegenerate: '',
			app: props.history.location?.state?.app,
			signinUrl: environment.appSetting.baseUrl + 'signin?appid=',
			customerEmail: '',
			userRole: accountService.getUserData().user.role,
		};
	}

	public render() {
		const appDataToShow = this.state.app;
		const gridValue = !accountService.IsAdmin(this.state.userRole) ? 8 : 12;
		return (
			<React.Fragment>
				<Grid container={true} spacing={2}>
					<Grid item={true} lg={gridValue} md={gridValue} sm={12} xs={12}>
						<Grid container={true} spacing={2}>
							<Grid item={true} lg={12} md={12} sm={12} xs={12}>
								<Accordion>
									<AccordionSummary
										expandIcon={<Icon name='chevron-down' />}
										aria-controls='panel1a-content'
										id='panel1a-header'
									>
										<Typography variant='h6' color='inherit'>
											{this.props.intl.formatMessage({
												id: 'app.api-key.api-key-secret',
											})}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<SecretKeySettingComponent appDataToShow={appDataToShow} onApiKeyRegenerated={this.generateKey} />
									</AccordionDetails>
								</Accordion>
							</Grid>
							<Grid item={true} lg={12} md={12} sm={12} xs={12}>
								<Accordion defaultExpanded={true}>
									<AccordionSummary
										expandIcon={<Icon name='chevron-down' />}
										aria-controls='panel1a-content'
										id='panel1a-header'
									>
										<Typography variant='h6' color='inherit'>
											{this.props.intl.formatMessage({
												id: 'app.api-key.carrier-account-label',
											})}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<CarrierViewComponent
											appId={this.state.app.appId}
											isRoutedFrom={this.props.history.location.state.extraParams?.isRoutedFrom}
										/>
									</AccordionDetails>
								</Accordion>
							</Grid>
						</Grid>
					</Grid>
					{!accountService.IsAdmin(this.state.userRole) && (
						<Grid item={true} lg={4} md={4} sm={12} xs={12}>
							{this.appSideView()}
						</Grid>
					)}
				</Grid>
			</React.Fragment>
		);
	}

	private generateKey = (app: models.IAccountAppResponseVM) => {
		this.setState({
			app,
		});
	};
	private appSideView = () => (
		<Grid container={true} spacing={2}>
			<Grid item={true} lg={12} md={12} sm={12} xs={12}>
				<Card raised={false}>
					<CardHeader
						title={this.state.app.appName}
						titleTypographyProps={{
							variant: 'h6',
						}}
						subheader={
							this.state.app.partnerName &&
							`${intlService.GetFormattedMessage('app.app-view.app-card.app-edit-appType-published-by')} ${
								this.state.app.partnerName
							}`
						}
						subheaderTypographyProps={{
							variant: 'caption',
						}}
					/>
					<CardContent>
						<Typography variant='body2'>{this.state.app.appDescription}</Typography>
						{this.state.app.apiVersion && (
							<Typography variant='body2'>
								{intlService.GetFormattedMessage('app.api-key.api-version')}: {this.state.app.apiVersion}
							</Typography>
						)}
						{!!this.state.app.dateCreated ? (
							<Typography variant='body2'>
								{intlService.GetFormattedMessage('app.api-key.installed-on')}:{' '}
								<FormattedDate
									{...constants.dateFormatOptions}
									value={sharedService.getNewDateIfNotExist(this.state.app.dateCreated)}
								/>
							</Typography>
						) : null}
					</CardContent>
				</Card>
			</Grid>
			<Grid item={true} lg={12} md={12} sm={12} xs={12}>
				<Card raised={false}>
					<CardHeader
						title={intlService.GetFormattedMessage('app.api-key.code-samples-and-sdk')}
						titleTypographyProps={{
							variant: 'h6',
						}}
					/>
					<CardContent>
						<Typography variant='body2'>
							{intlService.GetFormattedMessage('app.api-key.code-samples-and-sdk-description')}
						</Typography>
					</CardContent>
					{this.state.app.helpUrl && (
						<CardActions>
							<Button size='small' variant='text' onClick={(e) => window.open(this.state.app.helpUrl, '_blank')}>
								{intlService.GetFormattedMessage('app.api-key.code-samples-and-sdk-action-button')}
							</Button>
						</CardActions>
					)}
				</Card>
			</Grid>
		</Grid>
	);
}
export default withStyles(styles)(injectIntl(AccountAppComponent));



// WEBPACK FOOTER //
// ./src/components/account/app/account-app.component.tsx